// ABOUTME: Derives the configurator currency from the browser locale.
// ABOUTME: US locales resolve to usd, every other locale falls back to eur.

export const getBrowserCurrency = (): 'usd' | 'eur' =>
    new Intl.Locale(navigator.language).maximize().region === 'US' ? 'usd' : 'eur';
